const utcMs = (value) => {
  const ms = Date.parse(`${String(value ?? '').trim().replace(' ', 'T')}Z`);
  return Number.isNaN(ms) ? null : ms;
};

export const formatChallengeExpiry = (expiresAt) => {
  const parsed = utcMs(expiresAt);
  if (parsed == null) return String(expiresAt || '');
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'America/Sao_Paulo',
    hourCycle: 'h23',
  }).format(parsed);
};

// Diferença entre o relógio do servidor e o do aparelho no momento da emissão.
export const challengeClockOffset = (serverNowIso, receivedAtMs) => {
  const serverMs = Date.parse(String(serverNowIso || ''));
  if (Number.isNaN(serverMs) || !Number.isFinite(receivedAtMs)) return 0;
  return serverMs - receivedAtMs;
};

// Mesma regra do servidor: o código vale até o fim do segundo de expiresAt.
export const challengeCountdown = (expiresAt, nowMs, offsetMs = 0) => {
  const expires = utcMs(expiresAt);
  if (expires == null) return { expired: true, remaining: 0 };
  const serverNow = nowMs + offsetMs;
  if (serverNow >= expires + 1000) return { expired: true, remaining: 0 };
  return { expired: false, remaining: Math.max(0, Math.ceil((expires - serverNow) / 1000)) };
};

export const formatCountdown = (seconds) => {
  const safe = Math.max(0, Math.floor(seconds));
  return `${Math.floor(safe / 60)}:${String(safe % 60).padStart(2, '0')}`;
};
